@if (infoTop()) {
  @if (topLink()) {
    <a class="info info--top" [routerLink]="topLink()">{{ infoTop() }}</a>
  } @else {
    <div class="info info--top">{{ infoTop() }}</div>
  }
}
@if (winnerId()) {
  <div class="player player--winner">
    <lib-player [player]="winnerId()!" [darkText]="true" />
    @if (winnerId() === breakerId()) {
      <span class="breaker-marker">(<abbr title="breaker">B</abbr>)</span>
    }
  </div>
  <div class="info">beat</div>
  <div class="player player--loser">
    <lib-player
      [player]="winnerId() === playerOneId() ? playerTwoId() : playerOneId()"
      [darkText]="true"
    />
    @if (winnerId() !== breakerId()) {
      <span class="breaker-marker">(<abbr title="breaker">B</abbr>)</span>
    }
  </div>
} @else {
  <div class="player">
    <lib-player [player]="breakerId() || playerOneId()" [darkText]="true" />
  </div>
  <div class="info info--versus">
    {{ breakerId() ? 'to break against' : 'versus' }}
  </div>
  <div class="player">
    <lib-player
      [player]="breakerId() === playerTwoId() ? playerOneId() : playerTwoId()"
      [darkText]="true"
    />
  </div>
}
@if (infoBottom()) {
  <div class="info info--bottom">{{ infoBottom() }}</div>
}
